import instantsearch from "instantsearch.js";
import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import { configure } from 'instantsearch.js/es/widgets';
import SearchBox from './components/searchbox';
import Hits from './components/hits';
import { singleIndex } from "instantsearch.js/es/lib/stateMappings";

function initInstantSearch(el, data, Alpine) {
    let additionalSearchParameters = {
        query_by: "title,seoDescription,seoKeywords,sku",
        num_typos: '1,1,1,0',
        typo_tokens_threshold: 1,
        exhaustive_search: true,
        sortBy: '_text_match:desc',
        filterBy: data.filter,
    };

    const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
        server: {
            apiKey: data.apiKey, // Be sure to use an API key that only allows searches, in production
            nodes: [
                {
                    host: data.host,
                    port: data.port,
                    protocol: data.protocol,
                },
            ],
            connectionTimeoutSeconds: 5,
            numRetries: 8,
            cacheSearchResultsForSeconds: 2 * 60, // Cache search results from server. Defaults to 2 minutes. Set to 0 to disable caching.
        },
        // The following parameters are directly passed to Typesense's search API endpoint.
        //  So you can pass any parameters supported by the search endpoint below.
        //  query_by is required.
        additionalSearchParameters: additionalSearchParameters,
    });

    const searchClient = {
        ...typesenseInstantsearchAdapter.searchClient,
        search(requests) {
            if (requests.every(({ params }) => !params.query)) {
                return Promise.resolve({
                    results: requests.map(() => ({
                        hits: [],
                        nbHits: 0,
                        nbPages: 0,
                        page: 0,
                        processingTimeMS: 0,
                        hitsPerPage: 0,
                        exhaustiveNbHits: false,
                        query: '',
                        params: '',
                    })),
                })
            }

            return typesenseInstantsearchAdapter.searchClient.search(requests)
        }
    };

    let config = {
        searchClient,
        indexName: data.index,
        routing: {
            stateMapping: singleIndex(data.index),
        }
    };
    
    const search = instantsearch(config);

    search.addWidgets([
        configure({
                hitsPerPage: 12,
        }),
    ])

    Alpine.bind(el, {
        'x-data'() {
            return {
                __searchClient: searchClient,
                __search: search,
            }
        },
        'x-init'() {
            this.$data.__search.start();
        }
    });

}


export default function (Alpine) {
    Alpine.directive('search', (el, { value, expression }, { evaluate, Alpine }) => {
        // this is the top level component x-search
        if (!value) {
            initInstantSearch(el, evaluate(expression), Alpine);
        }
        if (value == 'searchbox') {
            SearchBox(el, Alpine);
        }
        if (value == 'hits') {
            Hits(el, Alpine);
        }
    }).before('bind');
}
